import React from 'react';
import {connect} from 'react-redux';
import resolvePath from '../../../misc/resolvePath';
import Validate from '../../validate/Validate';
import EventAttachment from '../EventAttachments/EventAttachment';

const findAttachment = (state, props) => {
    return _(state)
        .chain()
        .get(`events[${props.eventId}].questions.indexed[${props.questionId}].answers.data`, [])
        .find(answer => answer.id == props.answerId)
        .get('attachments')
        .find(attachment => attachment.id == props.attachmentId)
        .value();
};

const EventImageAttachmentConnectedToState = connect((state, props) => {
    let event = state.events[props.eventId].event,
        question = state.events[props.eventId].questions.indexed[props.questionId];

    return {
        event,
        attachment: findAttachment(state, props),
        returnURL: '../..',
    };
})(EventAttachment);

export default props => (
    <Validate
        validate={state => {
            if (!findAttachment(state, props.match.params)) {
                throw new Error('Attachment not found: ' + props.attachmentId);
            }
        }}
        onError={() => {
            app.history.replace(resolvePath(app.history.location.pathname, '..', '..'));
        }}>
        <EventImageAttachmentConnectedToState {...props.match.params} />
    </Validate>
);
